// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Tutaj wklej swój obiekt firebaseConfig ↓
const firebaseConfig = {
  apiKey: "AIzaSyBAp4FkOHBzxpcsVRFkwH1H1KhNNQOSW2w",
  authDomain: "calculator-bb1f3.firebaseapp.com",
  projectId: "calculator-bb1f3",
  storageBucket: "calculator-bb1f3.firebasestorage.app",
  messagingSenderId: "530464987934",
  appId: "1:530464987934:web:b33a20adfe9675f6a4870f"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app); // <-- DODAJ TO
